module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-27.aba945c4.png";